<template>
  <main class="main page-inside payment-result-page">
    <div class="main-wrapper">
      <div class="section hero-section">
        <div class="wrapper">
          <div class="title big" v-if="status === 'success'">
            {{ $t('Payout completed successfully!') }}
          </div>
          <div class="title big" v-else-if="status === 'failure'">
            {{ $t('Payout failed') }}
          </div>
          <div class="title big" v-else>
            {{ $t('Payout is being processed') }}
          </div>

          <div class="desc" v-if="status === 'success'">
            {{ $t('Your funds have been transferred successfully.') }}
          </div>
          <div class="desc" v-else-if="status === 'failure'">
            {{ $t('There was an issue processing your payout. Please contact support.') }}
          </div>
          <div class="desc" v-else-if="message">
            {{ message }}
          </div>
          <div class="desc" v-else>
            {{ $t('Your payout is being processed. You will be notified once it\'s complete.') }}
          </div>

          <div class="buttons">
            <router-link to="/sell-offers" class="button">
              <span>{{ $t('Back to my offers') }}</span>
            </router-link>
            <router-link to="/" class="button orange-btn">
              <span>{{ $t('Go to home') }}</span>
            </router-link>
          </div>
        </div>
      </div>
    </div>
  </main>
</template>

<script>
export default {
  name: 'PayoutResultPage',
  props: {
    status: {
      type: String,
      default: 'pending',
      validator: (value) => ['success', 'failure', 'pending'].includes(value),
    },
    message: {
      type: String,
      default: '',
    },
  },
};
</script>

<style scoped>
.buttons {
  margin-top: 32px;
  display: flex;
  gap: 16px;
  flex-wrap: wrap;
  justify-content: center;
  align-items: center;
}

.button {
  display: inline-flex;
  justify-content: center;
  align-items: center;
  padding: 14px 28px;
  text-transform: uppercase;
}
</style>
